import styled from '@mui/system/styled'
import CircularProgress from '@mui/material/CircularProgress'

export const StyledLoading = styled(CircularProgress)(() => ({
  width: '24px !important',
  height: '24px !important',
}))
